"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Advertising = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var CardRenderer_1 = require("../render/CardRenderer");
var Advertising = (function (_super) {
    __extends(Advertising, _super);
    function Advertising() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.ADVERTISING,
            tags: [Tags_1.Tags.EARTH],
            cost: 4,
            metadata: {
                cardNumber: 'X13',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.effect('When you play a card with a basic cost of 20 M€ or more, increase your M€ production 1 step.', function (be) {
                    be.megacredits(20).asterix().startEffect.production(function (pb) { return pb.megacredits(1); });
                }); }),
            },
        }) || this;
    }
    Advertising.prototype.onCardPlayed = function (player, card) {
        if (card.cost >= 20) {
            player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
        }
    };
    Advertising.prototype.play = function () {
        return undefined;
    };
    return Advertising;
}(Card_1.Card));
exports.Advertising = Advertising;
